
import { User } from '../../system/types';

// Sample user data
export const sampleUsers: User[] = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john.doe@jspark.in',
    role: 'admin',
    department: 'IT Operations',
    status: 'active',
    lastLogin: '2025-04-08T09:30:00Z',
    directorySource: 'local'
  },
  {
    id: '2',
    name: 'Alice Smith',
    email: 'alice.smith@jspark.in',
    role: 'manager',
    department: 'Engineering',
    status: 'active',
    lastLogin: '2025-04-07T14:15:00Z',
    directorySource: 'local'
  },
  {
    id: '3',
    name: 'Bob Johnson',
    email: 'bob.johnson@jspark.in',
    role: 'operator',
    department: 'Maintenance',
    status: 'inactive',
    lastLogin: '2025-03-25T11:45:00Z',
    directorySource: 'active-directory'
  },
  {
    id: '4',
    name: 'Emma Wilson',
    email: 'emma.wilson@jspark.in',
    role: 'viewer',
    department: 'Finance',
    status: 'active',
    lastLogin: '2025-04-08T08:20:00Z',
    directorySource: 'active-directory'
  }
];

export const roleLabels: Record<string, string> = {
  admin: 'Administrator',
  manager: 'Manager',
  operator: 'Operator',
  viewer: 'Viewer'
};
